import { createClient } from '@/shared/api';
import GENERATE_HOLTER_REPORT_MUTATION from '@/entities/report/api/mutations/generateHolterReport';
import type {
  GenerateHolterReportMutation,
  GenerateHolterReportMutationVariables,
} from '@/shared/api/generated/graphql';

export type GenerateHolterReportResult = {
  isSuccess: boolean;
  message: string;
  isReady: boolean;
  processingStudyFids: string[];
  simultaneousStudyLimit: number;
};

// TODO(ts): typed as the GenerateHolterReportInput GraphQL input once its server-side shape is documented
/**
 * Starts generation of a holter report on the server. Runs the generateHolterReport mutation and throws the server message on failure.
 *
 * @param input - Mutation input describing the report to generate.
 * @returns A promise resolving to the generateHolterReport result.
 */
const handleGenerateHolterReport = async (input: any) => {
  const client = await createClient();
  const generateHolterReportResult = await client.mutate<
    GenerateHolterReportMutation,
    GenerateHolterReportMutationVariables
  >({
    mutation: GENERATE_HOLTER_REPORT_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = generateHolterReportResult;
  const { generateHolterReport } = data;
  if (!generateHolterReport.isSuccess) {
    throw new Error(generateHolterReport.message);
  }
  return generateHolterReport;
};

export default handleGenerateHolterReport;
